import { Paper } from "@mui/material";
import { GlobalStateCard } from "./GlobalStateCard";
import { MetricDetailsTabs } from "./MetricDetailsTabs";
import { useAllEegData } from "../utils/useEeegData";
import { useDataFilter } from "./DataFilter";
import { EEGRecording, EEGMetric, PairFrequencyBand, EegDataRecord } from "../types";
import { useState } from "react";
import { RawDataValidationModal } from "./RawDataValidationModal";

type ModalInfo = {
    open: boolean;
    title: string;
    records?: Array<EegDataRecord>;
};

type EEGDashboardProps = {
    firstEEG: EEGRecording;
    secondEEG: EEGRecording;
    metrics: Array<EEGMetric>;
    bandFrequencyPairs: Array<PairFrequencyBand>;
};

export const EEGDashboard = ({ firstEEG, secondEEG, metrics, bandFrequencyPairs }: EEGDashboardProps) => {
    const { selectedFilter } = useDataFilter();
    const [modalInfo, setModalInfo] = useState<ModalInfo>({ open: false, title: "", records: [] });

    const handleCloseModal = () => {
        setModalInfo({ open: false, title: "", records: [] });
    };

    const allEegData = useAllEegData({
        firstEEG,
        secondEEG,
        selectedFilter,
    });

    const showDataInTable = (metricName: string, rawData: Array<EegDataRecord>) => {
        setModalInfo({ open: true, title: metricName, records: rawData });
    };

    return (
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column", gap: 6 }}>
            <GlobalStateCard
                showDataInTable={showDataInTable}
                metrics={metrics}
                firstEEG={firstEEG}
                secondEEG={secondEEG}
                bandFrequencyPairs={bandFrequencyPairs}
                allEegData={allEegData}
            />
            <MetricDetailsTabs
                metrics={metrics}
                showDataInTable={showDataInTable}
                firstEEG={firstEEG}
                secondEEG={secondEEG}
                allEegData={allEegData}
            />
            <RawDataValidationModal
                open={modalInfo.open}
                onClose={handleCloseModal}
                title={modalInfo.title}
                eegData={modalInfo.records}
            />
        </Paper>
    );
};
